import { render, staticRenderFns } from "./InvoicesToPayNewForm.vue?vue&type=template&id=b4fec5e0"
import script from "./InvoicesToPayNewForm.vue?vue&type=script&lang=js"
export * from "./InvoicesToPayNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports